// src/components/BotIntro.jsx
import React from 'react';
import { Box, Typography, Avatar, Button, useTheme } from '@mui/material';
import { motion } from 'framer-motion';

function BotIntro() {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  return (
    <Box
      sx={{
        height: '100vh',
        color: theme.palette.text.primary ,
        px: { xs: 2, sm: '10%', md: '10%' },
        py: { xs: 5, md: 34 },
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: 'center',
        justifyContent: { xs: 'center', md: 'center' },
        gap: 5
      }}
    >
      {/* 왼쪽 프사 */}
      <motion.div
        initial={{ x: -50, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <Box sx={{ textAlign: 'center' }}>
          <Avatar
            src="/profile.webp"
            alt="봇"
            sx={{
              width: { xs: 200, sm: 250, md: 400 },
              height: { xs: 200, sm: 250, md: 400 },
              mx: 'auto',
            }}
          />
        </Box>
      </motion.div>

      {/* 오른쪽 텍스트와 버튼 */}
      <motion.div
        initial={{ x: 50, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <Box
          sx={{
            textAlign: { xs: 'center', md: 'center' },
            mx: { xs: 'auto', md: 0 },
            width: '100%',
            maxWidth: '800px',
          }}
        >
          <Typography
            variant="h4"
            sx={{
              fontWeight: 'bold',
              mb: 1,
              fontSize: { xs: '2.3rem', sm: '3rem', md: '4rem' },
              whiteSpace: { xs: 'normal', md: 'nowrap' },
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              color: theme.palette.mode === 'light' ? '#7ab4f5' : theme.palette.text.primary,
            }}
          >
            간편하고 편리한 전적이
          </Typography>

          <Typography
            sx={{
              mt: { xs: 0, sm: -1, md:0 },
              mb: 3,
              fontSize: { xs: '1rem', sm: '1.3rem' },
              lineHeight: 1.5,
            }}
          >
            명령어 하나로 전적 검색부터 재미까지 잡은 디스코드 봇
          </Typography>

          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              gap: 2,
              justifyContent: { xs: 'center', sm: 'center', md: 'center' },
              alignItems: 'center',
            }}
          >
            <Button
              component="a"
              href="/invite" 
              target="_blank"
              variant="contained"
              sx={{
                color: '#fff',
                fontWeight: 'bold',
                backgroundColor: "#686662",
                '&:hover': { backgroundColor: '#595854' },
                px: 4,
                width: { xs: '100%', sm: '45%', md: '50%' },
                height: 50,
                fontSize: { xs: '1.2rem', sm: '1.1rem', md: '1.2rem' },
              }}
            >
              초대하기
            </Button>
            <Button
              component="a" 
              href="/docs"
              variant="outlined"
              color="inherit"
              sx={{
                fontWeight: 'bold',
                width: { xs: '100%', sm: '45%' , md: '50%' },
                height: 50,
                fontSize: { xs: '1.2rem', sm: '1.1rem', md: '1.2rem' },
              }}
            >
              자세히 알아보기
            </Button>
          </Box>
        </Box>
      </motion.div>
    </Box>
  );
}

export default BotIntro;
